import { Button } from "@mantine/core";

import classes from "./smaui-button.module.css";

export const SmaUiButton = (props) => {
    return (<Button classNames={classes} {...props} />);
}